import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { useClickOutside } from '@sopranodesign/pulse-component-hooks';

import useTooltip, { POSITIONS } from '../../hooks/useTooltip';
import TooltipPopup from '../Tooltip/TooltipPopup';
import DefaultButton from '../Button/Button';
import Flex from '../Layout/Flex';

const ActionMenu = ({
  children,
  position = POSITIONS.BOTTOM,
  Button = DefaultButton,
  buttonProps = {},
  closeOnClickOutside = true,
  setIsOpen = null
}) => {
  const [visible, setVisible] = useState(false);

  const tooltip = useTooltip({
    visible,
    position,
    tooltip: children
  });

  const handleClickOutside = useCallback(() => {
    if (closeOnClickOutside) {
      setVisible(false);
    }
    if (setIsOpen) {
      setIsOpen(false);
    }
  }, [closeOnClickOutside, setIsOpen]);

  useClickOutside(handleClickOutside, { ref: tooltip.ref });

  const handleClick = () => {
    setVisible(visible => !visible);
    if (setIsOpen) {
      setIsOpen(visible => !visible);
    }
  };

  return (
    <Flex relative left ref={tooltip.ref}>
      <Button
        variant="inline"
        onClick={handleClick}
        icon="dotsHorizontal"
        {...buttonProps}
      />
      <TooltipPopup {...tooltip.props} />
    </Flex>
  );
};

ActionMenu.propTypes = {
  position: PropTypes.oneOf(Object.values(POSITIONS)),
  Button: PropTypes.func,
  buttonProps: PropTypes.object,
  closeOnClickOutside: PropTypes.bool,
  setIsOpen: PropTypes.func
};
ActionMenu.POSITIONS = POSITIONS;

export default ActionMenu;
